import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';

/** Demo: always allow mutations (no payment lock). */
export function useAccess() {
  const featureKeys = useSelector((state: RootState) => state.auth.featureKeys);
  const operationsLocked = false;

  const can = useCallback(
    (featureKey: string) =>
      featureKeys.length === 0 || featureKeys.includes(featureKey),
    [featureKeys],
  );

  const canMutate = useCallback(
    (_featureKey?: string) => true,
    [],
  );

  return { can, canMutate, featureKeys, operationsLocked };
}
